import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';
import { vehicleChassisProperty, vehicleFuelTypeInput, vehicleRegistryInput } from '../vehicle-registry.config';

export const MOBILE_HOME = {
  nickname: 'PRODUCTS.MOBILE_HOME.shortname',
  vehicleRegistryMode: true,
  properties: [
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{5}/)
      ]]
    },
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_1', value: '70,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_2', value: '70,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_3', value: '70,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_1', value: '75,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_2', value: '75,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3', value: '75,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_4+', value: '75,4+' }
        ]
      }
    },
    {
      name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'mobileHomeMarketValue', key: 'MARKET_VALUE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      SUM_INSURED_THOUSANDS_ONLY: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^(?:[1-9]\d*)000$/)
      ]]
    },
    {
      name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(1)
    },
    {
      name: 'tffVehicleModel', key: 'TFF_VEHICLE_MODEL', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(2)
    },
    {
      name: 'vehicleRentalCarCover', key: 'RENTAL_CAR_COVER_KOLIBRI', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'ofvFirstTimeRegYear', key: 'OFV_FIRST_TIME_REG_YEAR', group: 'INSURANCE_INFO',
      ...vehicleRegistryInput(3)
    },
    {
      name: 'vehicleFuelType', key: 'VEHICLE_FUEL_TYPE', group: 'OBJECT_INFO',
      ...vehicleFuelTypeInput(4)
    },
    {
      name: 'tffVehicleWeight', key: 'TFF_VEHICLE_WEIGHT', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(5)
    },
    vehicleChassisProperty(6),
    {
      name: 'vehicleDrivingLength', key: 'DRIVING_LENGTH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.16', value: '16000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.25', value: '25000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.30', value: '30000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.40', value: '40000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.50', value: '50000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.70', value: '70000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.100', value: '100000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LENGTH.UNLIMITED', value: '999999' }
        ]
      }
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' }
        ]
      }
    },
    {
      name: 'vehicleDrivingLengthReadingKm', key: 'DRIVING_LENGTH_READING_KM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleDrivingLengthReadingDate', key: 'DRIVING_LENGTH_READING_DATE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'month'
      }
    }
  ],
  icon: 'mobile-home'
};
